import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class HeaderInterceptorService implements HttpInterceptor {

    constructor() { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url.includes(environment.api)) {
            req = req.clone({
                setHeaders: {
                    'Accept': `application/json, text/plain, */*`,
                }
            });

            const currentUrl = window?.location?.href ?? '';

            if (currentUrl) {
                req = req.clone({
                    setHeaders: {
                        'X-Current-Url': currentUrl
                    }
                });
            }
        }

        return next.handle(req);
    }
}
